import { render, staticRenderFns } from "./KeywordKey.vue?vue&type=template&id=375fb696&"
import script from "./KeywordKey.vue?vue&type=script&lang=js&"
export * from "./KeywordKey.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('375fb696')) {
      api.createRecord('375fb696', component.options)
    } else {
      api.reload('375fb696', component.options)
    }
    module.hot.accept("./KeywordKey.vue?vue&type=template&id=375fb696&", function () {
      api.rerender('375fb696', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/inputs/KeywordKey.vue"
export default component.exports